/* Next10 — troca de variante nos cards da vitrine.
   Atualiza imagem, preco, preco comparado, selo de desconto e link do produto
   quando o cliente escolhe outro sabor na pilula do card. */
(function () {
  if (window.__n10CardVariantes) return;
  window.__n10CardVariantes = true;

  function dados(card) {
    var el = card.querySelector('.n10-card__dados');
    if (!el) return null;
    if (el.__n10cache !== undefined) return el.__n10cache;
    try { el.__n10cache = JSON.parse(el.textContent); }
    catch (e) { el.__n10cache = null; }
    return el.__n10cache;
  }

  function aplicar(card, v, esconderAlt) {
    var img = card.querySelector('.n10-card__img:not(.n10-card__img--alt)');
    if (img && v.img600) {
      img.setAttribute('src', v.img600);
      img.setAttribute('srcset', v.img300 + ' 300w, ' + v.img600 + ' 600w, ' + v.img900 + ' 900w');
      if (v.alt) img.setAttribute('alt', v.alt);
      if (esconderAlt) {
        var alt = card.querySelector('.n10-card__img--alt');
        if (alt) alt.style.display = 'none';
      }
    }

    var preco = card.querySelector('.n10-card__price');
    if (preco && v.preco) preco.textContent = v.preco;

    var comparar = card.querySelector('.n10-card__compare');
    if (comparar) {
      if (v.comparar) {
        comparar.textContent = v.comparar;
        comparar.style.display = '';
      } else {
        comparar.style.display = 'none';
      }
    }

    var selo = card.querySelector('.n10-card__badge:not(.n10-card__badge--esgotado)');
    if (selo) {
      if (v.desconto > 0) {
        selo.textContent = '-' + v.desconto + '%';
        selo.style.display = '';
      } else {
        selo.style.display = 'none';
      }
    }

    var link = card.querySelector('.n10-card__link');
    if (link && v.url) link.setAttribute('href', v.url);
  }

  function trocar(input, esconderAlt) {
    var card = input.closest ? input.closest('.n10-card') : null;
    if (!card) return;
    var lista = dados(card);
    if (!lista) return;
    for (var i = 0; i < lista.length; i++) {
      if (String(lista[i].id) === String(input.value)) {
        aplicar(card, lista[i], esconderAlt);
        return;
      }
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('n10-card__opt-input')) {
      trocar(t, true);
    }
  });

  function inicial() {
    var marcados = document.querySelectorAll('.n10-card__opt-input:checked');
    for (var i = 0; i < marcados.length; i++) trocar(marcados[i], false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicial);
  } else {
    inicial();
  }
})();
